import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Icon } from './icons';
import { FileBadge } from './figures';

/** Document tile with a small paper icon and file type (design/Vertragsakte, Wohnung "Dokumente"). */
export function FileTile({ title, sub, ext = 'PDF', to, href, onClick, busy }: { title: ReactNode; sub?: ReactNode; ext?: string; to?: string; href?: string; onClick?: () => void; busy?: boolean }) {
  const body = (
    <>
      <FileBadge ext={ext} />
      <span className="ft-text">
        <span className="ft-title">{title}</span>
        {sub && <span className="ft-sub">{sub}</span>}
      </span>
    </>
  );
  if (to) return <Link to={to} className="file-tile">{body}</Link>;
  if (href) return <a href={href} className="file-tile" target="_blank" rel="noreferrer">{body}</a>;
  if (onClick) return <button type="button" className="file-tile" onClick={onClick} aria-busy={busy || undefined} disabled={busy}>{body}</button>;
  return <div className="file-tile static">{body}</div>;
}

/** Dashed "+ add" tile next to FileTiles. */
export function AddTile({ children, to, onClick }: { children: ReactNode; to?: string; onClick?: () => void }) {
  const inner = <><Icon name="plus" size={16} strokeWidth={2} />{children}</>;
  return to ? <Link to={to} className="add-tile">{inner}</Link> : <button type="button" className="add-tile" onClick={onClick}>{inner}</button>;
}
